<template>
  <page :title="$tc('comment._name')" size="is-tablet">
    <div class="box">
      <search-filter @filter="onFilter"></search-filter>
    </div>
    <infinite-scroll :collection="comments" v-if="comments">
      <comment-box v-for="comment in comments.data" :key="comment.id" :comment="comment"></comment-box>
    </infinite-scroll>
  </page>
</template>

<script>
import InfiniteScroll from "./../../../../components/InfiniteScroll";
import CommentBox from "./../../../../components/comment/CommentBox";
import SearchFilter from "../../components/filters/review/Index";

export default {
  components: {
    InfiniteScroll,
    CommentBox,
    SearchFilter
  },

  created() {
    this.load();
  },

  data() {
    return {
      comments: null
    };
  },

  methods: {
    load() {
      this.comments = new window.LazyLoadingRemoteCollection(
        "/admin/api/reviews?include=user,latest_five_replies"
      ).transform(comment => (comment.more = false));
    },
    onFilter(filters) {
      if (filters) {
        this.comments
          .with(filters)
          .reset()
          .load();
      } else {
        this.comments.reset();
        this.load();
        this.comments.load();
      }
    }
  }
};
</script>
